import { render } from "./HomeTilesMenuItem.vue?vue&type=template&id=be96e096&scoped=true"
import script from "./HomeTilesMenuItem.vue?vue&type=script&lang=js"
export * from "./HomeTilesMenuItem.vue?vue&type=script&lang=js"

import "./HomeTilesMenuItem.vue?vue&type=style&index=0&id=be96e096&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be96e096"]])

export default __exports__